import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-card-widget',
  templateUrl: './card-widget.component.html',
  styleUrls: ['./card-widget.component.scss']
})
export class CardWidgetComponent {

  @Input()
  title: string;

  @Input()
  subtitle: string;

  @Input()
  expanded = false;

  constructor() { }

  toggle(): void {
    this.expanded = !this.expanded;
  }

}
